import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function RequireAuth({ children }) {
  const { user, refresh } = useAuth();
  const location = useLocation();
  const [rechecked, setRechecked] = useState(false);
  // A transient /auth/me failure must not send a logged-in user to the login form: re-check once.
  useEffect(() => {
    if (user === false && !rechecked) refresh().finally(() => setRechecked(true));
  }, [user, rechecked, refresh]);
  if (user === null || (user === false && !rechecked)) {
    return (
      <div className="flex justify-center py-24" data-testid="auth-loading">
        <Loader2 className="h-10 w-10 animate-spin text-orange-500" />
      </div>
    );
  }
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/entrar?next=${next}`} replace />;
  }
  return children;
}
